module.exports = __webpack_public_path__ + "img/account-active.6bacfc57.svg";